import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { SetColorsService } from '../../../services/set-colors.service'

@Component({
  selector: 'bmcore-color-settings',
  templateUrl: './bmcore-color-settings.component.html',
  styleUrls: ['./bmcore-color-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreColorSettingsComponent implements OnInit {
  isColorSettingsOpen = false

  constructor(private setColorsService: SetColorsService) {}

  ngOnInit(): void {
    this.setColorsService.colorSettingsSubject.subscribe(res => {
      this.isColorSettingsOpen = res
    })
  }

  openSettings() {
    this.setColorsService.notifyComponent(!this.isColorSettingsOpen)
  }
}
